<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：平台活动问答-编辑
    -->
    <div v-loading="loading" class="goods-add pb50">
        <!--编辑-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">编辑问答</div>
            <el-form-item label="问题" prop="question">
                <el-input type="textarea" :rows="2" v-model="form.question" placeholder="请输入问题" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="答案" prop="answer">
                <Uediter ref="ue2" editor_id="ue2" v-if="ueLoaed" :text="form.answer" :config="ueditor.config" @contentChange="contentChangeFunc"></Uediter>
            </el-form-item>
            <el-form-item label="排序"><el-input v-model="form.sort" type="number" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Uediter from "@/components/UE.vue";

    export default {
        components: {
            /*编辑器*/
            Uediter,
        },
        data() {
            return {
                /*富文本框配置*/
                ueditor: {
                    text: "",
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    question_id:"",
                    activity_id:"",
                    question: "",
                    answer: "",
                    sort: 1,
                    status: "0"
                },
                activityData:[],
                loading: false,
                ueLoaed: false,
                /*验证规则*/
                rules: {
                    activity_id: [{ required: true, message: "请选择活动", trigger: "blur" }],
                    question: [{ required: true, message: "请输入问题", trigger: "blur" }],
                    answer: [{ required: true, message: "请输入答案", trigger: "blur" }]
                }
            };
        },
        created() {
            this.getDetail();
        },

        methods: {
            /*获取富文本框内容*/
            getContent: function() {
                //return this.$refs.ue.getUEContent();
            },

            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.answer = e;
            },

            getDetail() {
                let self = this;
                // 取到路由带过来的参数
                const params = self.$route.query.question_id;
                this.loading = true;
                this.ueLoaed = false;
                PlatformActivityApi.question.detail({ question_id: params }, true)
                    .then((res) => {
                        self.loading = false;
                        self.ueLoaed = true;
                        self.form = res.data.detail;
                        self.ueditor.text = res.data.detail.answer;
                        self.activityData = res.data.activity.data;
                        self.loading = false;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*修改文章*/
            onSubmit() {
                let self = this;
                let params = this.form;
                // 取到路由带过来的参数
                PlatformActivityApi.question.edit(params, true)
                    .then((data) => {
                        self.$message({
                            message: data.msg,
                            type: "success"
                        });
                        self.$router.back();
                    })
                    .catch((error) => {

                    });
            },

            /*取消添加，返回列表*/
            cancelFunc() {
                this.$router.back();
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/question/edit.vue